import { Route, Routes, useLocation } from "react-router-dom";
import { AppHeader } from "../header/header";
import { TrainerPage } from "../../pages/trainer-page";
import { ProfilePage } from "../../pages/profile-page";
import { LoginPage } from "../../pages/login-page";
import { TrialsPage } from "../../pages/trials-page";
import { DrillPage } from "../../pages/drill-page";
import { HighscoresPage } from "../../pages/highscores-page";
import { useEffect } from "react";
import { checkUserAuth } from "../../services/login/actions";
import { useDispatch } from "../../services/hooks";
import { OnlyAuth, OnlyUnAuth } from "../protected-route/protected-route";
import { Error } from "../error/error";
import { GoogleOAuthCallback } from "../google-oauth-callback/google-oauth-callback";
import styles from "./app.module.css";
import { AppFooter } from "../footer/footer";

export default function App(): JSX.Element {
  const dispatch = useDispatch();
  let location = useLocation();
  let state = location.state;

  useEffect(() => {
    dispatch(checkUserAuth());
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <div className={styles.shell}>
        <AppHeader />
        <Routes location={state?.backgroundLocation || location}>
          <Route path="/" element={<TrainerPage />} />
          <Route
            path="/profile/*"
            element={<OnlyAuth component={<ProfilePage />} />}
          ></Route>
          <Route
            path="/trials"
            element={<OnlyAuth component={<TrialsPage />} />}
          ></Route>
          <Route
            path="/drill"
            element={<OnlyAuth component={<DrillPage />} />}
          ></Route>
          <Route
            path="/highscores"
            element={<OnlyAuth component={<HighscoresPage />} />}
          ></Route>
          <Route
            path="/login"
            element={<OnlyUnAuth component={<LoginPage />} />}
          ></Route>
          <Route path="/google-oauth-callback" element={<GoogleOAuthCallback />} />
          <Route
            path="*"
            element={<Error errorText={"Error 404 - page not found"} />}
          />
        </Routes>
        <AppFooter/>
        </div>
      </div>
    </div>
  );
}
